<style scoped>
</style>

<template>
    <u-table-column
        :prop="col.prop"
        :label="col.label"
        align="center"
        v-if="!col.show"
        :fixed="col.fixed"
		:width="col.width"
        :height="height"
        :render-header="renderHeader"
        :show-overflow-tooltip="true"
        >
        <template v-if="col.children && !col.show">
            <multi-type-pl-column
                v-for="(item, index) in col.children"
                :key="index"
                :col="item"
                :editField="editField"
				:width="width"
                :height="height"
                :unEditRow="unEditRow"
                :required ="required"
                :editFieldType="editFieldType"
                :pasteField="pasteField"
                :editFildHide="editFildHide"
                :formatterList="formatterList"
                :tableData="tableData"
                @loseFocus="loseFocus"
                @pasteData="pasteData"
                @modification="modificationa">
            </multi-type-pl-column>
             <!-- <el-input /> -->
        </template>
        <template slot-scope="scope">
            <el-input @paste.native="onPaste(scope.$index,col.prop)"  @focus='getfocus("text",$event,col,scope.$index,scope.row)' @blur.prevent="dblur('text',$event,scope.row,col.prop)" v-model="scope.row[col.prop]"  v-if="editField.indexOf(col.prop) != -1 && editFieldType[editField.indexOf(col.prop)]=='text' && !isNoEditRow && !col.noNeedControl&&unEditRow.indexOf(scope.$index)== -1" placeholder="请输入" :maxlength="100" size="small"  type="text" @keydown.native="channelInputLimit($event,scope.row,col.prop,col)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope,scope.$index)" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');value=value>=1?value.replace(/^[0]+/,''):value;"/>
            <!-- 整数 -->
            <el-input @paste.native="onPaste(scope.$index,col.prop)"  @focus='getfocus("text",$event,scope.$index,scope.row)' @blur.prevent="dblur('text',$event,scope.row,col.prop)" v-model="scope.row[col.prop]"  v-if="editField.indexOf(col.prop) != -1 && editFieldType[editField.indexOf(col.prop)]=='number' && !isNoEditRow && !col.noNeedControl&&unEditRow.indexOf(scope.$index)== -1" placeholder="请输入" :maxlength="100" size="small"  type="number" @keydown.native="channelInputLimit($event,scope.row,col.prop,col)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)" oninput="value=value.replace(/[^0-9]/g,'');value=value>=1?value.replace(/^[0]+/,''):value;" onKeyPress="if (event.keyCode==46) event.returnValue=false"/>
            <el-input @paste.native="onPaste(scope.$index,col.prop)"  @focus='getfocus("text",$event,scope.$index,scope.row)' @blur.prevent="dblur('text',$event,scope.row,col.prop)" v-model="scope.row[col.prop]"  v-if="editField.indexOf(col.prop) != -1 && editFieldType[editField.indexOf(col.prop)]=='text' && !isNoEditRow && col.noNeedControl&&unEditRow.indexOf(scope.$index)== -1" placeholder="请输入" :maxlength="100" size="small"  />
            <el-date-picker @paste.native="onPaste(scope.$index,col.prop)" v-else-if="editField.indexOf(col.prop) != -1  && editFieldType[editField.indexOf(col.prop)]=='date'"
            @focus='getfocus("date",$event,col,scope.$index,scope.row)' @blur="dblur('date',$event,scope.row,col.prop)"
                v-model="scope.row[col.prop]"
                style="width: 100%"
                type="date"
                value-format="timestamp"
                :picker-options="scope.row.pickerOptions"
                placeholder="请选择"
                :editable="false"
                prefix-icon="return fasle">
            </el-date-picker>
            <span v-if="editField.indexOf(col.prop) == -1||unEditRow.indexOf(scope.$index)!= -1">{{strGetVal(col.prop,scope)}}</span>
        </template>
        
        
    </u-table-column>
</template>

<script>
// import moment from 'moment'
export default {
    name: "multi-type-pl-column",
    data() {
        return {
            sth:"",
            field:[],
            computedField:{},
            tLength:"",//tableDate长度
            focusIndex:"",
            focusProp:""
        };
    },
    props: {
        tableData:{
            type: Array
		},
        col: {
            type: Object
        },
        editField:{
            type: Array,
            default:function(){
                return []
            }
        },
        editFieldType:{
            type: Array
        },
		width:{
			type: String
		},
		height:{
			type: String
        },
        required:{
            type: Boolean
        },
        formatterList:{
            type: Array
        },
        editFildHide:{
            type: Array,
            default:function(){
                return []
            }
        },
        unEditRow:{
            type: Array,
            default:function(){
                return []
            }
        },
        isNoEditRow:{
            type:Boolean
        },
        pasteField:{
            type: Array
        }
    },
    created(){
    },
    methods: {
        // render 事件
		renderHeader (h,{column}) { // h即为cerateElement的简写，具体可看vue官方文档
			// 当需要显示tip信息时
			if( this.col.isShowTip ){
                let info ="";
                if(column.property == "1"){
                    info="执行中-中标价/开票价取价格平台该省份该产品最新的申请通过的<br/>中标价和开票价，如没有数据，则说明该产品目前未中标";
                }else if(column.property == "2"){
                    info="预计中标价/执行时间默认给出投标<br/>管理部的意见，如有异议请修改";
                }else if(column.property == "3"){
                    info="开票价下浮比例默认给出预计发货政策<br/>的比例，如有异议请修改";
                }else{
                    info= `<table style="border-collapse:collapse;text-align:center;margin-bottom:10px">
                                <tr>
                                    <td style="border:1px solid #000;padding: 8px" colspan="3">执行中-中标价/开票价</td>
                                    <td style="border:1px solid #000;padding: 8px" colspan="2">预计中标价</td>
                                    <td style="border:1px solid #000;padding: 8px" colspan="2">预计开票价</td>
                                    <td style="border:1px solid #000;padding: 8px" colspan="3">综合扣减</td>
                                    <td style="border:1px solid #000;padding: 8px" colspan="2">最终计算后价格</td>
                                </tr>
                                <tr>
                                    <td style="border:1px solid #000;padding: 8px">执行中中标价a</td>
                                    <td style="border:1px solid #000;padding: 8px">执行中开票价b</td>
                                    <td style="border:1px solid #000;padding: 8px">执行中下浮比例c</td>
                                    <td style="border:1px solid #000;padding: 8px">预计中标价A</td>
                                    <td style="border:1px solid #000;padding: 8px">预计执行时间t</td>
                                    <td style="border:1px solid #000;padding: 8px">预计下浮比例C</td>
                                    <td style="border:1px solid #000;padding: 8px">预计开票价B</td>
                                    <td style="border:1px solid #000;padding: 8px">产品税率d</td>
                                    <td style="border:1px solid #000;padding: 8px">回款、流向折扣e</td>
                                    <td style="border:1px solid #000;padding: 8px">简易计税补差f</td>
                                    <td style="border:1px solid #000;padding: 8px">执行中n</td>
                                    <td style="border:1px solid #000;padding: 8px">预计中标后N</td>
                                </tr>
                            </table>
                            中标价预计执行时间t时间前 n=b*（1-e-f）/（1+d)） b=a/（1+c）<br>
                            中标价预计执行时间t时间后 N=B*（1-e-f）/（1+d) B=A/（1+C）`;
                }
				return h('div',{style:'display:flex;justify-content:center'},[ 
					// h('span', {style:'color:#323232,position:fixed,top:0,left:0,background-color:#fed11b'},'我是tip'),
					h('span', column.label),
					h('tipDialog', {
						props:{
							message:{
								tipInfo:info,
								title:column.label
							}
						}
					})
				])
			}
            if(this.required) {
                if(this.editField.indexOf(column.property) != -1 && this.editFildHide.indexOf(column.property) == -1) {
                	return h('div',{style:'display:flex;justify-content:center;align-items:center'},[ 
                        h('span', {style:'color:#ff0101'},'*'),
                        h('span', column.label)
                    ])
				}else {
                    return column.label;
                }
            }else {
                return column.label;
            }
            
            
        },
         //失去焦点
		loseFocus(e){
			this.$emit("loseFocus",this.tableData);
		},
        //获取到焦点
        getfocus(type,e,col,index,row){
            let rowprop = eval('row.'+col.prop);
            
            this.focusIndex = index;
            this.focusProp = col.prop;
            if(type == "text"){
                e.target.type = "number";
                 this.$nextTick(()=>{
                    setTimeout(()=>{
                        e.target.type="text";
                        if(rowprop){
                            e.target.value = this.delcommafy(rowprop);
                        }
                        e.target.selectionStart = e.target.value.length;
                    },30);
                });
            }
            if(type == 'date'){
                e.$el.children[0].className = 'get-focus el-input__inner';
            }else{
                e.target.className = 'get-focus el-input__inner';
            }
            
        },
        //失去焦点
        dblur(type,e,row,prop){
           if(type=="text"){
                e.target.type = "text";
                e.target.value = this.commafy(e.target.value);
           }
           if(type == 'date'){
                e.$el.children[0].className = 'el-input__inner';
            }else{
                e.target.className = 'el-input__inner';
            }
            this.computedField = {row:row,prop:prop};
            this.$emit("loseFocus", this.computedField);
			// if( row.adviseStartExecDate <= row.invoicePriceStartExecDate){ //中标价执行时间必须小于等于开票价执行时间
			// 	if(type == 'date'){
			// 		e.$el.children[0].className = 'el-input__inner';
			// 	}else{
			// 		e.target.className = 'el-input__inner';
			// 	}
			// 	this.computedField = {row:row,prop:prop};
			// 	this.$emit("loseFocus", this.computedField);
			// }else{
			// 	if( prop == "adviseStartExecDate" && row.invoicePriceStartExecDate ){
			// 		row.adviseStartExecDate = "";
			// 		this.$message({
			// 			message: '中标价执行时间必须小于等于开票价执行时间',
			// 			type: 'error'
			// 		});
			// 	}else if( prop == "invoicePriceStartExecDate" && row.adviseStartExecDate ){
			// 		row.invoicePriceStartExecDate = "";
			// 		this.$message({
			// 			message: '中标价执行时间必须小于等于开票价执行时间',
			// 			type: 'error'
			// 		});
			// 	}else{
			// 		if(type == 'date'){
			// 			e.$el.children[0].className = 'el-input__inner';
			// 		}else{
			// 			e.target.className = 'el-input__inner';
			// 		}
			// 		this.computedField = {row:row,prop:prop};
			// 		this.$emit("loseFocus", this.computedField);
			// 	}
			// }
        },
        //去除千分位
        delcommafy(num){
            if((num+"").trim()==""){
                return num;
            }
            num = num+"";
            num = num.replace(/,/gi,'');
            return num;
        },
         // 数字格式转换成千分位
        commafy(num){
            if((num+"").trim()=="" || isNaN(num) || num == null){
                return num;
            }
            num = num+"";
            if(/^.*\..*$/.test(num)){
            let pointIndex =num.lastIndexOf(".");
            let intPart = num.substring(0,pointIndex);
            let pointPart =num.substring(pointIndex+1,num.length);
            intPart = intPart +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(intPart)){
                intPart =intPart.replace(re,"$1,$2")
                }
            num = intPart+"."+pointPart;
            }else{
                num = num +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(num)){
                num =num.replace(re,"$1,$2")
                }
            }
            return num;
        },
        strGetVal(row,scope,index){
            if(this.formatterList && this.formatterList.indexOf(scope.column.property) != -1) {//日期格式化
				let dataStr = eval('scope.row.'+row );
                if(dataStr){
                    return moment(parseInt(dataStr)).format('YYYY-MM-DD');
                }else{
                    return "";
                }
			}else if(this.formatteColumn && this.formatteColumn.name.indexOf(scope.column.property) != -1){
				return  this.formatteColumn.list[eval('scope.row.'+row )-1];
			}else if(row == "sfSales"){
                if(scope.row.sfSales){
                    if(scope.row.sfSales == "0"){
                        return "未上市";
                    }else{
                        return "已上市";
                    }
                }
            }else{
                if((this.focusIndex == index && this.editField.indexOf(this.focusProp) != -1) || row == 'materialCode'){
                    return  eval('scope.row.'+row);
                }else{
                    return this.commafy(eval('scope.row.'+row ))
                }
            }
        },
         substrClipTest(clipText,data){
            let index = clipText.indexOf("\r\n");
            if(index > -1){
                let rowResult = clipText.slice(0,index).split("\t");
                data.push(rowResult);
                let text = clipText.slice(index+2);
                if(text.indexOf("\r\n") > -1){
                     this.substrClipTest(text,data);
                }
                return data;
            }
        },
         onPaste(index,prop){
            //如果不满足 黏贴列表传空pasteField=[]
            if(this.pasteField&&this.pasteField.length>0){
                navigator.clipboard.readText().then((clipText)=>{//
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        let editData = []; 
                        //2.结果集处理成对象 类型，字段名，内容
                        result.forEach((value,key)=>{
                            let data = [];
                            let startVal =false,i=0;
                            this.pasteField.forEach((editValue,editKey)=>{
                                if((editValue.name == prop || startVal)&&value[i]!=undefined){//2个字段相等就开始， 直到数组遍历完
                                    startVal =true;
                                    let obj={type:editValue.type,key:editValue.name,value:value[i],isCover:editValue.isCover};
                                    data.push(obj);
                                    i++;
                                }
                            });
                            editData.push(data);
                        });
                        this.tLength=this.tableData.length
                        //3.结果集 写入到表里面
                        editData.forEach((value,key)=>{
                            value.forEach((innerValue,innerKey)=>{
                                if(index+key<this.tLength){
                                    //每种类型的处理
                                    if(innerValue.isCover){
                                        if(innerValue.type == "number"){
                                            this.tableData[index+key][innerValue.key] = parseFloat(innerValue.value);
                                        }else if(innerValue.type == "date"){
                                            this.tableData[index+key][innerValue.key] = moment(innerValue.value).valueOf();
                                        }else{
                                            this.tableData[index+key][innerValue.key] = innerValue.value;
                                        }
                                    }
                                }
                            });
                        });
                        //公共处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }else{
                 navigator.clipboard.readText().then((clipText)=>{//
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        //自己处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }
            
        },
        pasteData(e){
            this.$emit("pasteData",e);
        },
        //input 监听
		modificationa(e){
			this.$emit("modification",e);
        },
        // 键盘监控
        getFocusKeydown(e){
            let that = this;
            $(e.target).keydown(function(e) {
                if (e.ctrlKey && (e.keyCode == 86)){
                    console.log(that.currentCol,"Document catch Ctrl+V")
                    // that.onPaste(that.currentIndex,that.currentCol);
                } 
                
            });
        },
        channelInputLimit(e,row,prop,col){
            let maxLength = col.maxLength;
            let rowprop = eval('row.'+prop );
            if(JSON.stringify(rowprop) == "null"){
                 rowprop="";
            }
            let key = e.key;
            let ctrlKey=e.ctrlKey
            //限制长度
            if((rowprop+"").length> maxLength && key !== "Backspace"){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //小数点前多少位判断
            let index = (rowprop+"").indexOf(".");
            let selectionStart=e.target.selectionStart;
            if(key === "Backspace"){
                selectionStart = selectionStart-1;
            }
            console.log((rowprop+""));
            console.log((rowprop+"").length);
            if((index == -1 && (rowprop+"").length > maxLength-3 && key !== "Backspace" && key !== ".")|| (index>-1&&index == maxLength-2&&index>=selectionStart && key !== "Backspace")){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            
            // col.isInteger?value=value.replace(/^[0-9]*[1-9][0-9]*$/g,''):
            // let rowprop = eval('row.'+prop );
            // let key = e.key;
            // //限制长度
            // if((rowprop+"").length>10 && key !== "Backspace"){
            //     e.preventDefault ? e.preventDefault() : (e.returnValue = false);
            //     return false;
            // }
            // //整数的时候 不能输入小数点
            // if(col.isInteger && key === '.'){
            //     e.preventDefault ? e.preventDefault() : (e.returnValue = false);
            //     return false;
            // }
            // var reg = /^\d+$|^\d*\.\d+$/g;
            // if (key === '.' ) {
            //     if(  rowprop == "" || this.tempkey =='.' || rowprop.toString().indexOf('.') !=-1){
            //        e.preventDefault ? e.preventDefault() : (e.returnValue = false);
            //         return false;
            //     }else{
            //         this.tempkey = key;
            //         return true;
            //     }
            // }else if(reg.test(key) || key === "Backspace" || (row.isFuShu && (key === 'Process' || key==='-'))){
            //     this.tempkey = "";
            //     return true;
            // }else{
            //     e.preventDefault ? e.preventDefault() : (e.returnValue = false);
            //     return false;
            // }
        },
        //输入监听 index下标 row 一行数据 prop 属性 e值 新数组
        inputFunc(index,row,prop,e){
            // console.log(index,row,prop,e);
            //防滚鼠标
            // e=e.replace(/[^\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');
            // e=e.replace(/[^\d.]/g,"");
            //.toFixed(2)
            //  if(!(/^(\d+\.?)?\d{0,2}$/.test(e))){
            //      console.log(/^(\d+\.?)?\d{0,2}$/.test(e),eval('row.'+prop));
            //     e = parseFloat(eval('row.'+prop));
            // }
            let that = this;
            eval('row.'+prop+"= e" );
            if(that.tableData !=undefined){
                var new_arr = JSON.parse(JSON.stringify(that.tableData));
                new_arr[index] = row;
                //回掉事件
                that.$emit("modification", {index:index,row:row,prop:prop,val:e,tableData:new_arr});
            }
        }
    }
};
</script>
<style scoped>
</style>
